import {get, post} from "@/config/api";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  UploadImage({}, params) {
    let config = {
      headers: { //添加请求头
        'Content-Type': 'multipart/form-data'
      }
    }
    return new Promise((resolve, reject) => {
      post("wt/media/image/upload/", params, config).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  PageSettings({}, params) {
    return new Promise((resolve, reject) => {
      get(`base/settings/app_settings/`, params).then((data) => {
        resolve(data);
      }, (error) => {
        reject(error)
      })
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
